// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2HM3m","description":"PatientConsentPreview_description__3m2VA"};